// Action Types
export const POS_GET_INVENTORY = "POS_GET_INVENTORY";
export const POS_GET_INVENTORY_SUCCESS = "POS_GET_INVENTORY_SUCCESS";
export const POS_GET_INVENTORY_ERROR = "POS_GET_INVENTORY_ERROR";

// Action Creators
export const getPosInventory = (data, token) => ({
    type: POS_GET_INVENTORY,
    payload: data,
    token
});

export const getPosInventorySuccess = (items) => ({
    type: POS_GET_INVENTORY_SUCCESS,
    payload: items
});

export const getPosInventoryError = (error) => ({
    type: POS_GET_INVENTORY_ERROR,
    payload: error
});